<template>
    <div class="">
      <div class="q-mb-sm q-mt-md">
        <h6 class="title-h6 process-color">{{$t('processes.add_stage')}}</h6>
        <q-card flat bordered class="q-pa-sm q-mb-md collapsible-div">
          <q-card-section class="justify-center">
            <div class="row q-gutter-sm">
              <base-input-text class="col q-pb-none" :label="$t('processes.fields.nom_stage.label')" placeholder="Description" :color="color"
                v-model="stage.label" />
              <base-input-date class="col q-pb-none" :label="$t('processes.fields.date_debut.label')" placeholder="Description" :color="color"
                v-model="stage.date_debut" />
            </div>
            <div class="row">
              <div class="col-6">
                <base-input-date class="col q-pb-none" :label="$t('processes.fields.date_fin.label')" placeholder="Description" :color="color"
                v-model="stage.date_fin" />
              </div>
            </div>
            <div class="row q-mt-md justify-end">
              <div class="col col-3 q-py-sm q-px-md">
                <q-btn class="full-width" color="process" size="sm" @click="addStage()">{{$t('processes.add')}}</q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div v-if="stages.length">
        <div class="q-gutter-sm row q-px-lg q-my-md">
          <div class="col-8" v-html="$t('processes.fields.nom_stage.label')" />
          <div class="col" v-html="$t('processes.fields.date_debut.label')" />
          <div class="col" v-html="$t('processes.fields.date_fin.label')" />
        </div>
        <div v-for="stage in stages" :key="stage.id" >
          <q-card flat bordered class="q-pa-sm q-mb-none">
            <q-card-section class="q-py-none">
              <div class="q-gutter-sm row">
                <span class="col-8" v-html="`${stage.label}`" />
                <span class="col" v-html="`${$formatDate(stage.date_debut)}`" />
                <span class="col" v-html="`${$formatDate(stage.date_fin)}`" />
                <q-icon class="col-1 q-pb-sm cursor-pointer" name="delete_forever" @click="removeStage(stage.id)" size="1.5rem" />
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: { },

  data () {
    return {
      filter: {},
      loading: false,
      isFormOpen: false,
      isUpdate: this.$route.params.id,
      stage: {}
    }
  },

  computed: {
    ...mapGetters({
      color: 'pages/getColor',
      isAdmin: 'auth/isAdmin',
      stages: 'processes/getProcesses'
    })
  },

  beforeDestroy () {
    this.$store.commit('processes/setProcesses', [])
  },

  mounted () {
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } }
    ])
    this.$store.commit('pages/setPageTitle', this.$t('processes.title.administration'))

    this.$store.commit('pages/setTabs', [
      { name: 'stage-fiche', label: this.$t('processes.stage_process_suivi_de_recrutement'), to: { name: 'stage-fiche' }, params: { } },
      { name: 'objectif-fiche', label: this.$t('processes.objectif_process_suivi_de_nomination'), to: { name: 'objectif-fiche' }, params: { } }
    ])
  },

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchProcesses', { typeProcess: 'consoleAdmin/stage' })
  },
  methods: {
    addStage () {
      let params = {
        ...this.stage,
        model_type: 'consoleAdmin/stage'
      }
      this.$store.dispatch('processes/saveProcesses', params).then(data => {
        this.$store.dispatch('processes/fetchProcesses', { typeProcess: 'consoleAdmin/stage' })
      })
    },
    removeStage (idStage) {
      let params = {
        id: idStage,
        type: 'consoleAdmin/stage'
      }
      this.$store.dispatch('processes/deleteProcesses', params).then((response) => {
        this.$q.notify({
          message: 'Stage supprimé',
          color: 'positive'
        })
        this.$store.dispatch('processes/fetchProcesses', { typeProcess: 'consoleAdmin/stage' })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
